import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/services/admin/admin.service';
import { AppService } from 'src/app/services/app/app.service';
import { TranslateService } from '@ngx-translate/core';
import { ThemeService } from 'src/app/services/theme/theme.service';
import { Router } from '@angular/router';
import { SpinnerComponent } from 'src/app/components/layout/spinner/spinner.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-create-app',
  standalone: true,
  imports: [
    SpinnerComponent,
    CommonModule,
    FormsModule
  ],
  templateUrl: './create-app.component.html',
  styleUrls: ['./create-app.component.css']
})
export class CreateAppComponent {

  @Output() reloadapps = new EventEmitter<void>();
@Input() domain = '';

get isDomainValid(): boolean {

  return /^[a-z0-9]+$/.test(this.domain);

}

  peyIfarem = false

  form!: FormGroup;
  error: any;
  loading = false;
  loadingMessage = '';
  messages = [
    'MESSAGES.PLEASE_WAIT',
    'MESSAGES.PREPARING_SITE',
    'MESSAGES.ALMOST_THERE',
    'MESSAGES.HANG_TIGHT',
    'MESSAGES.ON_THE_WAY',
    'MESSAGES.FEW_SECONDS'
  ];
  messageIndex = 0;
  interval: any;
  
  load = false
  isPackage = false

  business_type = 'restaurant'

  constructor(
    public AppService: AppService,
    private fb: FormBuilder,
    private admin: AdminService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef,
    private ThemeService: ThemeService,
    private Router: Router
  ) {
    this.form = fb.group({
      subdomain: [this.domain, [Validators.required, Validators.pattern(/^[a-zA-Z0-9]+$/)]],
      business_type: ['1', Validators.required],  // Radio ველი რესტორნის ან სასტუმროს არჩევისთვის
      package: [20, Validators.required], // Radio ველი პაკეტის არჩევისთვის
      duration: ['1', Validators.required]  // თვეების რაოდენობა, მომხმარებელს შეუძლია აირჩიოს რამდენი ხნით უნდა გადახდა
    });
    this.checkPackage()
  }

  checkPackage(){
    const userId = this.admin.user?.id;
    if (userId !== undefined && userId !== null) {
      this.load = true
      this.AppService.show(userId.toString()).subscribe(
        (res: any) => {
          // console.log(res.length)
          if(res.length === 0){
            this.isPackage = true
          }else{
            this.isPackage = false
          }
          // console.log(res)
          this.load = false
          this.error = false
        },
        (error: any) => {
          // console.log(error)
          this.error = true
          this.load = false
        }
      )
    } else {
      console.error('user_id is undefined or null');
      // Handle the undefined or null case appropriately
    }
  }


  pey(data: any){
    this.loading = true;
    this.AppService.pey(data).subscribe(
      (res: any) => {
        this.loading = false;
        // console.log('მისამართი: ', res[0]._links.details.href)
        // window.location.href = res[0]._links.details.href;
        if (res && res.payment_url) {
          const paymentUrl = res.payment_url + '&theme=' + this.ThemeService.getThemes();
          console.log('Payment URL:', paymentUrl);
          // window.open(paymentUrl);
          // გადახდის ბმულის ჩასმა iframe-ში
          // this.openPaymentIframe(paymentUrl);
          // window.open(paymentUrl, '_blank', 'width=800,height=600'); // გახსნის ახალ ფანჯარაში

          window.location.href = paymentUrl; // გადამისამართება იმავე ფანჯარაში

        } else {
          console.error('Payment URL not found in response:', res);
          // შეცდომის დამუშავება
        }
      },
      (err) => {
        this.loading = false;
        console.error('Payment request failed:', err);
        // შეცდომის დამუშავება
      }
    );
  }
normalizeDomain(value: string): void {
  this.domain = (value || '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');

  this.form.get('subdomain')?.setValue(this.domain);
}

closeModal(): void {
  if (this.loading) {
    return;
  }

  this.AppService.close();
}
create(pack: string): void {
  this.normalizeDomain(this.domain);

  if (!this.domain) {
    this.toastr.error(
      this.translate.instant('VALIDATION.SUBDOMAIN.REQUIRED')
    );

    return;
  }

  if (!this.isDomainValid) {
    this.toastr.error(
      this.translate.instant('VALIDATION.SUBDOMAIN.REGEX')
    );

    return;
  }

  if (!this.admin.user?.id) {
    this.toastr.error('მომხმარებელი ვერ მოიძებნა.');
    return;
  }

  this.loading = true;
  this.startLoadingMessages();

  const data = {
    subdomain: this.domain,
    business_type: this.business_type,
    package: pack,
    duration: this.form.get('duration')?.value || '1',
    user_id: this.admin.user.id
  };

  this.AppService.create(data).subscribe({
    next: (res: any) => {
      this.loading = false;
      this.stopLoadingMessages();

      this.reloadapps.emit();
      this.AppService.close();

      this.toastr.success(
        res?.message || 'რესტორანი წარმატებით შეიქმნა.'
      );

      this.setApp({
        subdomain: res?.app?.sub_domain,
        app_id: res?.app?.id
      });

      this.Router.navigate([
        '/app/setup',
        res?.app?.id
      ]);
    },

    error: (error: any) => {
      this.loading = false;
      this.stopLoadingMessages();

      this.error =
        error?.error?.error ||
        error?.error?.message ||
        'რესტორნის შექმნა ვერ მოხერხდა.';

      const backendMessage = error?.error?.message;

      const subdomainError =
        error?.error?.errors?.subdomain?.[0];

      if (backendMessage === 'UNPAID_APPLICATION') {
        this.toastr.error(
          this.translate.instant(
            'VALIDATION.UNPAID_APPLICATION'
          )
        );

        return;
      }

      if (subdomainError === 'SUBDOMAIN.REGEX') {
        this.toastr.error(
          this.translate.instant(
            'VALIDATION.SUBDOMAIN.REGEX'
          )
        );

        return;
      }

      if (subdomainError === 'SUBDOMAIN.REQUIRED') {
        this.toastr.error(
          this.translate.instant(
            'VALIDATION.SUBDOMAIN.REQUIRED'
          )
        );

        return;
      }

      if (backendMessage === 'app.payment_required') {
        this.toastr.error(
          this.translate.instant(
            'app.payment_required'
          )
        );

        return;
      }

      this.toastr.error(
        backendMessage ||
        'რესტორნის შექმნა ვერ მოხერხდა.'
      );

      console.error('Create restaurant error:', error);
    }
  });
}


  validateForm() {
    for (const field in this.form.controls) {
      const control = this.form.get(field);
      if (control && control.invalid) {
        const errorKey = Object.keys(control.errors || {})[0];
        this.translate.get(`VALIDATION.${errorKey.toUpperCase()}`).subscribe((translatedMessage) => {
          this.toastr.error(translatedMessage);
        });
      }
    }
  }

  startLoadingMessages() {
    this.loadingMessage = this.translate.instant(this.messages[this.messageIndex]);
    this.interval = setInterval(() => {
      this.messageIndex = (this.messageIndex + 1) % this.messages.length;
      this.loadingMessage = this.translate.instant(this.messages[this.messageIndex]);
    }, 10000); // Change message every 10 seconds
  }

  stopLoadingMessages() {
    clearInterval(this.interval);
  }

  setApp(data: any) {
    this.AppService.setApp(data).subscribe(() => {}, () => {});
  }

 
}